import * as S from './style';
import * as T from '../../../../../components/Typography';
import { Row, Col } from '../../../../../components/Grid';
import data from './data';

const Getbettamol2 = () => {
  return (
    <S.Wrapper>
      <Row mb="5">
        <Col w={[4, 6, 6]}>
          <T.H2 size="med">Getbettamol... the path to fast pain relief</T.H2>
        </Col>
      </Row>
      <Row mb="2">
        <Col w={[4, 10, 10]}>
          <T.P weight="bold">How to take this medicine</T.P>
        </Col>
      </Row>
      <Row mb="3">
        <Col w={[4, 10, 10]}>
          <T.P>Swallow the tablets with water at meal times or with food</T.P>
        </Col>
      </Row>
      <Row mb="2">
        <Col w={[4, 10, 10]}>
          <T.P weight="bold">Dose and how often to take:</T.P>
        </Col>
      </Row>
      <Row mb="2">
        <Col w={[4, 10, 10]}>
          <T.P>
            <T.P weight="bold" style={{ display: 'inline' }}>
              Children from 6 to 12 years:
            </T.P>{' '}
            half to one tablet up to four times a day.
          </T.P>
        </Col>
      </Row>
      <Row mb="5">
        <Col w={[4, 10, 10]}>
          <T.P>
            <T.P weight="bold" style={{ display: 'inline' }}>
              Adults, the elderly and children over 12 years:
            </T.P>{' '}
            take 1 or 2 tablets up to four times a day.
          </T.P>
        </Col>
      </Row>
      <Row mb="5">
        <Col w={[4, 10, 10]} dir="column" ai="flex-start">
          <T.P weight="bold" mb="2">
            This medicine is NOT suitable for children under six years old
          </T.P>
          {data.firstList.map((item) => (
            <S.ListItem key={item.key}>
              <S.BulletPoint /> <T.P>{item.text}</T.P>
            </S.ListItem>
          ))}
        </Col>
      </Row>
      <Row mb="5" mbT="4">
        <Col w={[4, 10, 10]} dir="column" ai="flex-start">
          <T.P mb="2">
            You
            <T.P weight="bold" ml="2" style={{ display: 'inline' }}>
              MUST
            </T.P>{' '}
            contact your doctor or health provider:
          </T.P>
          {data.secondList.map((item) => (
            <S.ListItem key={item.key}>
              <S.BulletPoint /> <T.P>{item.text}</T.P>
            </S.ListItem>
          ))}
        </Col>
      </Row>
    </S.Wrapper>
  );
};

export default Getbettamol2;
